const initSearchForm = (el) => {
  const $el = $(el);
  const $form = $el.find('#faq-search-form');
  const $input = $form.find('#faq-search-input');

  if ($input.length > 0) {
    $input.on('focus', () => {
      $input.attr('placeholder', '');
    });

    $input.on('blur', () => {
      if ($input.val() === '') {
        $input.attr('placeholder', 'Sök bland frågor och svar');
      }
    });
  }
}

export default initSearchForm;




